import styled from '@emotion/styled';

import { Container, TextBlockWithAside, TextBlockWithQuotes } from '@features';
import { getFont } from '@styles/mixins/fonts';
import { getMediaqueryStyled } from '@styles/mixins/mediaqueries';
import { sectionGridTemplateBase } from '@styles/mixins/sectionGridTemplate';

export const StyledContainer = styled(Container)`
  grid-template-areas:
    'first-title-part .'
    'second-title-part .'
    'text-block quote';
  padding-bottom: 425px;

  ${sectionGridTemplateBase};

  ${getMediaqueryStyled('xl')} {
    padding-bottom: 415px;
  }

  ${getMediaqueryStyled('lg')} {
    padding-bottom: 255px;
  }

  ${getMediaqueryStyled('md')} {
    grid-template-areas: 'first-title-part' 'second-title-part' 'quote' 'text-block';
    padding-bottom: 0;
  }
`;

const TitlePart = styled.span`
  ${getFont('title')}
`;

export const FirstTitlePart = styled(TitlePart)`
  grid-area: first-title-part;
  margin-bottom: var(--title-parts-margin);

  ${getMediaqueryStyled('xs')} {
    display: grid;

    .last-word {
      margin-left: 130px;
    }
  }
`;

export const SecondTitlePart = styled(TitlePart)`
  grid-area: second-title-part;
  margin-left: 245px;
  margin-bottom: 35px;

  ${getMediaqueryStyled('xl')} {
    margin-left: 190px;
  }

  ${getMediaqueryStyled('lg')} {
    margin-left: 115px;
  }

  ${getMediaqueryStyled('md')} {
    margin-left: 145px;
    margin-bottom: 40px;
  }

  ${getMediaqueryStyled('sm')} {
    margin-left: 0;
  }

  ${getMediaqueryStyled('xs')} {
    display: grid;

    .last-word {
      margin-left: 60px;
    }
  }
`;

export const TextBlock = styled(TextBlockWithAside)`
  grid-area: text-block;
  margin-top: 75px;

  ${getMediaqueryStyled('xl')} {
    margin-top: 55px;
  }
  ${getMediaqueryStyled('lg')} {
    margin-top: 35px;
  }

  ${getMediaqueryStyled('md')} {
    margin-top: 0;
  }
`;

export const Quote = styled(TextBlockWithQuotes)`
  grid-area: quote;
  align-self: start;

  ${getMediaqueryStyled('md')} {
    margin-bottom: 40px;
  }
`;

export const ReportButtons = styled.p`
  display: flex;
  width: 560px;
  align-items: stretch;
  justify-content: space-between;

  ${getMediaqueryStyled('lg')} {
    width: 312px;
  }

  ${getMediaqueryStyled('md')} {
    width: 465px;
  }

  ${getMediaqueryStyled('sm')} {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    row-gap: 20px;
  }
`;
